import { Tooltip as Tip, Button, Form, Input, DatePicker, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Select as AntdSelect } from "antd";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import { Table } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_HEADER,
  get_time_sheetData,
  get_project_task_RoleData,
  submit_timesheet,
  update_timesheet,
  get_sbu_time_sheetData
} from "../config";
import Header from "../Pages/Header";
import Footer from "./Footer";
import SideNavbar from "./SideNavbar";
import dayjs from "dayjs";
import moment from "moment";
import { exportTimesheet } from "./TimesheetReport";

const { Option } = Select;

const SBUTimesheet = () => {
  const dateFormat = "DD/MM/YYYY";
  const dateTimeFormat = "DD/MM/YYYY HH:mm";
  const [dataSource, setDataSource] = useState([]);
  const [loadData, setloadData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const [form] = Form.useForm();
  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [roles, setRoles] = useState([]);
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [action, setAction] = useState(false);
  const [additionalStatusOptions, setAdditionalStatusOptions] = useState([]);
  const [selectedAdditionalStatus, setSelectedAdditionalStatus] = useState([]);
  const [showAdditionalStatusColumn, setShowAdditionalStatusColumn] =
    useState(false);
  const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);

  const [filters, setFilters] = useState({
    project_id: null,
    task_id: null,
    role_id: null,
    status: null,
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const statusOptions = [
    "Work in progress",
    "Complete",
    "Allocated to other",
    "Cancelled",
  ];

  const isEditing = (record) => record.key === editingKey;

  const isCreatedToday = (createdAt) => {
    if (!createdAt) return false;
    const createdDate = dayjs(createdAt).format("YYYY-MM-DD");
    const today = dayjs().format("YYYY-MM-DD");
    return createdDate === today;
  };

  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination({
      ...pagination,
      ...newPagination,
    });
    setloadData(true);
  };

  const handleSearchByColumn = (value) => {
    if (startDate && endDate) {
      if (startDate.isAfter(endDate)) {
        alert("Start Date cannot be after End Date.");
        setendDate(null);
        setstartDate(null);
        return;
      }
    }
    setSearch(!search);
    allData();
  };

  const fetchProjectTaskRoleData = async () => {
    try {
      const response = await axios.get(
        `${get_project_task_RoleData}`,
        API_HEADER
      );
      setProjects(response.data.projects);
      setTasks(response.data.tasks);
      setRoles(response.data.roles);
      setAdditionalStatusOptions(response.data.deliverables || []);
    } catch (error) {
      console.error("Error fetching project/task/role data:", error);
      message.error("Failed to load project/task/role data");
    }
  };

  const edit = (record) => {
    if (!isCreatedToday(record.created_at)) {
      message.warning("You can only edit entries created today");
      return;
    }

    // Convert additional_status to the format expected by MultiSelect
    const initialAdditionalStatus = record.additional_status
      ? additionalStatusOptions.filter((opt) =>
          record.additional_status.some((item) =>
            typeof item === "string"
              ? item === opt.value
              : item.value === opt.value
          )
        )
      : [];

    form.setFieldsValue({
      project_id: record.project_id ? Number(record.project_id) : null,
      task_id: record.task_id ? Number(record.task_id) : null,
      role_id: record.role_id ? Number(record.role_id) : null,
      start_time: record.start_date ? dayjs(record.start_date) : null,
      end_time: record.end_date ? dayjs(record.end_date) : null,
      total_time: record.total_consumed_time || "0h 0m",
      status: record.status,
      additionalStatus: initialAdditionalStatus,
      isDocumentUploaded:
        record.is_document_uploaded !== null
          ? record.is_document_uploaded.toString()
          : null,
      remarks: record.remarks || "",
    });

    setSelectedAdditionalStatus(initialAdditionalStatus);
    setShowAdditionalStatusColumn(record.status === "Complete");
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
    setSelectedAdditionalStatus([]);
    setShowAdditionalStatusColumn(false);
    allData();
    setAction(false);
  };


  const save = async (key) => {
  try {
    const row = await form.validateFields();
    console.log("dataSource",dataSource)
    const record = dataSource.find((item) => key === item.key);

    if (!isCreatedToday(record.created_at)) {
      message.warning("You can only edit entries created today");
      return;
    }

    const payload = {
      project_id: row.project_id,
      task_id: row.task_id,
      role_id: row.role_id,
      start_time: row.start_time.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      end_time: row.end_time.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      total_time: row.total_time,
      status: row.status,
      additional_status:
        row.status === "Complete"
          ? selectedAdditionalStatus.map((item) => item.value)
          : null,
      is_document_uploaded:
        row.status === "Complete" ? row.isDocumentUploaded : null,
      remarks: row.remarks || "",
    };

    let response;
    console.log("record.proposal_id",record.id)
    let isUpdate = !!record.id;

if (isUpdate) {
  // Existing record - update
  response = await axios.post(
    `${update_timesheet}`,
    { ...payload, id: record.id },    //// change here timesheet_id to id in backend 
    API_HEADER
  );
} else {
  // New record - submit
  response = await axios.post(
    `${submit_timesheet}`,
    payload,
    API_HEADER
  );
}

    if (response.data.status) {
      message.success(
        isUpdate ? "Timesheet updated successfully" : "Timesheet saved successfully"
      );
      setEditingKey("");
      setSelectedAdditionalStatus([]);
      setShowAdditionalStatusColumn(false);
      setIsDocumentUploaded(false);
      allData();
      setAction(false);
    }
  } catch (errInfo) {
    console.log("Validate Failed:", errInfo);
    const record = dataSource.find((item) => key === item.key); // Define record here for the error message
    message.error(
      `Failed to ${record?.proposal_id ? "update" : "save"} timesheet`
    );
  }
};
  const calculateTimeDifference = (start, end) => {
    if (!start || !end) return "0h 0m";

    const diffInMs = end.valueOf() - start.valueOf();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    const hours = Math.floor(diffInHours);
    const minutes = Math.floor((diffInHours - hours) * 60);
    return `${hours}h ${minutes}m`;
  };

  const handleDateChange = (field, value) => {
    const otherField = field === "start_time" ? "end_time" : "start_time";
    const otherValue = form.getFieldValue(otherField);

    if (value && otherValue) {
      form.setFieldsValue({
        total_time: calculateTimeDifference(
          field === "start_time" ? value : otherValue,
          field === "end_time" ? value : otherValue
        ),
      });
    }
  };

  const addNewRow = () => {
    const newKey = `new_${Date.now()}`;
    const newRow = {
      key: newKey,
      project_id: null,
      task_id: null,
      role_id: null,
      start_time: null,
      end_time: null,
      total_time: "0h 0m",
      status: "",
      additional_status: [],
      is_document_uploaded: null, // Add this line
      remarks: "",
      created_at: new Date().toISOString(),
    };

    setDataSource([newRow, ...dataSource]);
    edit(newRow);
    setAction(true);
  };

  const allData = async () => {
    try {
      setLoader(true);

      const payload = {
        ...filters,
        start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
        end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
        page: pagination.current,
        limit: pagination.pageSize,
      };
      const response = await axios.post(
        `${get_sbu_time_sheetData}`,
        payload,
        API_HEADER
      );
      const dataWithKeys = response.data.timesheets.data.map((item) => ({
        ...item,
        key: item.proposal_id || `row_${Math.random()}`,
      }));
      setDataSource(dataWithKeys);
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: response.data.timesheets.total,
      }));
      setloadData(false);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching timesheet data:", error);
      setLoader(false);
      message.error("Failed to load timesheet data");
    }
  };

  const handleImmediateFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  useEffect(() => {
    allData();
    fetchProjectTaskRoleData();
  }, [loadData, filters]);

  useEffect(() => {
    if (!editingKey) {
      setShowAdditionalStatusColumn(false);
    }
  }, [editingKey]);

  const baseColumns = [
    {
      title: "S.No",
      dataIndex: "proposal_id",
      width: 20,
      render: (text, record, index) => {
        const pageIndex = (pagination.current - 1) * pagination.pageSize;
        return pageIndex + index + 1;
      },
    },
    {
      title: "EId / Project Name",
      width: 500,
      render: (text, record) => {
        const editable = isEditing(record);
        const project = projects.find((p) => p.id === record.project_id);
        return editable ? (
          <Form.Item
            name="project_id"
            rules={[{ required: true, message: "Please select project" }]}
          >
            <AntdSelect
              placeholder="Select Project"
              showSearch
              optionFilterProp="label"
              style={{ width: "200px" }}
              filterOption={(input, option) => {
                const label = option.label || "";
                return label.toLowerCase().includes(input.toLowerCase());
              }}
            >
              {projects.map((project) => (
                <AntdSelect.Option
                  key={project.id}
                  value={project.id}
                  label={`${project.earthood_id} / ${project.project_name}`}
                  title={` ${project.earthood_id} / ${project.project_name} `}
                >
                  {project.earthood_id} / {project.project_name}
                </AntdSelect.Option>
              ))}
            </AntdSelect>
          </Form.Item>
        ) : (
          <Tip title={record?.project_name || "N/A"}>
            <span
              className="textcolorgreen"
              style={{
                display: "inline-block",
                width: "300px", // Increased width when not editable
                // whiteSpace: 'nowrap',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis'
              }}
            >
              {record?.earthood_id || "N/A"} / {record?.project_name || "N/A"}
            </span>
          </Tip>
        );
      },
    },
    {
      title: "Task Name",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item
            name="task_id"
            rules={[{ required: true, message: "Please select task" }]}
          >
            <AntdSelect
              placeholder="Select Task"
              showSearch
              optionFilterProp="children"
              style={{ width: "200px" }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {tasks.map((task) => (
                <AntdSelect.Option key={task.id} value={task.id}>
                  {task.name}
                </AntdSelect.Option>
              ))}
            </AntdSelect>
          </Form.Item>
        ) : (
          <Tip title={record?.task_name || "N/A"}>
            <span className="textcolorgreen">{record?.task_name || "N/A"}</span>
          </Tip>
        );
      },
    },
    {
      title: "Role",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item
            name="role_id"
            rules={[{ required: true, message: "Please select role" }]}
          >
            <AntdSelect
              placeholder="Select Role"
              showSearch
              optionFilterProp="children"
              style={{ width: "200px" }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {roles.map((role) => (
                <AntdSelect.Option key={role.id} value={role.id}>
                  {role.name}
                </AntdSelect.Option>
              ))}
            </AntdSelect>
          </Form.Item>
        ) : (
          <Tip title={record?.role_name || "N/A"}>
            <span className="textcolorgreen">{record?.role_name || "N/A"}</span>
          </Tip>
        );
      },
    },
    {
      title: "Start Date",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item
            name="start_time"
            rules={[{ required: true, message: "Please select start date" }]}
          >
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format={dateTimeFormat}
              style={{ width: "200px" }}
              onChange={(value) => handleDateChange("start_time", value)}
              disabledDate={(current) => {
                const thirtyDaysAgo = moment()
                  .subtract(30, "days")
                  .startOf("day");
                const today = moment().endOf("day");
                return current && (current < thirtyDaysAgo || current > today);
              }}
            />
          </Form.Item>
        ) : (
          <Tip
            title={
              record.start_date
                ? dayjs(record.start_date).format(dateTimeFormat)
                : "N/A"
            }
          >
            <span className="textcolorgreen">
              {record.start_date
                ? dayjs(record.start_date).format(dateTimeFormat)
                : "N/A"}
            </span>
          </Tip>
        );
      },
    },
    {
      title: "End Date",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item
            name="end_time"
            rules={[
              {
                required: true,
                message: "Please select end date",
                validator: (_, value) => {
                  const startTime = form.getFieldValue("start_time");
                  if (!startTime) {
                    return Promise.reject("Please select start date first");
                  }
                  if (value && value.isBefore(startTime)) {
                    return Promise.reject("End time must be after start time");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format={dateTimeFormat}
              style={{ width: "200px" }}
              onChange={(value) => handleDateChange("end_time", value)}
              disabledDate={(current) => {
                const startTime = form.getFieldValue("start_time");
                const today = moment().endOf("day");

                if (!startTime) return true;

                return current < startTime.startOf("day") || current > today;
              }}
            />
          </Form.Item>
        ) : (
          <Tip
            title={
              record.end_date
                ? dayjs(record.end_date).format(dateTimeFormat)
                : "N/A"
            }
          >
            <span className="textcolorgreen">
              {record.end_date
                ? dayjs(record.end_date).format(dateTimeFormat)
                : "N/A"}
            </span>
          </Tip>
        );
      },
    },
    {
      title: "Total Time",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name="total_time" style={{ width: "200px" }}>
            <Input readOnly />
          </Form.Item>
        ) : (
          <Tip title={record.total_consumed_time || "N/A"}>
            <span className="textcolorgreen">
              {record.total_consumed_time || "N/A"}
            </span>
          </Tip>
        );
      },
    },
    {
      title: "Status",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item
            name="status"
            rules={[{ required: true, message: "Please select status" }]}
          >
            <AntdSelect
              placeholder="Select Status"
              style={{ width: "200px" }}
              onChange={(value) => {
                setShowAdditionalStatusColumn(value === "Complete");
                if (value !== "Complete") {
                  setSelectedAdditionalStatus([]);
                }
              }}
            >
              {statusOptions.map((status) => (
                <AntdSelect.Option key={status} value={status}>
                  {status}
                </AntdSelect.Option>
              ))}
            </AntdSelect>
          </Form.Item>
        ) : (
          <Tip title={record.status || "N/A"}>
            <span
              className={
                record.status === "Cancelled"
                  ? "text-red"
                  : record.status === "Complete"
                  ? "text-green"
                  : record.status === "Allocated to other"
                  ? "text-yellow"
                  : record.status === "Work in progress"
                  ? "text-blue"
                  : ""
              }
            >
              <span style={{ fontWeight: "bold" }}>
                {record.status || "N/A"}
              </span>
            </span>
          </Tip>
        );
      },
    },
    // ...(form.getFieldValue('status') === 'Complete'
    //   ? [
    {
      title: "Deliverables",
      width: 400,
      render: (text, record) => {
        const editable = isEditing(record);
        const recordStatus = editable
          ? form.getFieldValue("status")
          : record.status;

        if (recordStatus !== "Complete") return null;

        // Handle the display of additional status
        const displayAdditionalStatus = () => {
          if (!record.additional_status) return "N/A";

          // Handle both formats:
          // 1. Array of strings (old format)
          // 2. Array of objects with value/label (new format)
          if (Array.isArray(record.additional_status)) {
            return record.additional_status
              .map((item) => (typeof item === "string" ? item : item.label))
              .join(", ");
          }
          return "N/A";
        };

        return editable ? (
          <Form.Item
            name="additionalStatus"
            rules={[
              { required: true, message: "Please select additional status" },
            ]}
            style={{ width: "200px" }}
          >
            <MultiSelect
              options={additionalStatusOptions}
              value={selectedAdditionalStatus}
              onChange={setSelectedAdditionalStatus}
              labelledBy="Select additional status"
              disableSearch={false}
              hasSelectAll={false}
              className="multi-select"
              style={{ width: "200px" }}
            />
          </Form.Item>
        ) : (
          <Tip title={displayAdditionalStatus()}>
            <span
              className="textcolorgreen"
              style={{
                display: "inline-block",
                width: "200px", // Increased width when not editable
                // whiteSpace: 'nowrap',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis'
              }}
            >
              {displayAdditionalStatus()}
            </span>
          </Tip>
        );
      },
    },
    {
      title: "Updated on Earthlink",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        const recordStatus = editable
          ? form.getFieldValue("status")
          : record.status;

        if (recordStatus !== "Complete") return null;

        return editable ? (
          <Form.Item
            name="isDocumentUploaded"
            rules={[
              {
                required: true,
                message: "Please select document upload status",
              },
            ]}
          >
            <AntdSelect placeholder="Select" style={{ width: "200px" }}>
              <AntdSelect.Option value="1">Yes</AntdSelect.Option>
              <AntdSelect.Option value="0">No</AntdSelect.Option>
            </AntdSelect>
          </Form.Item>
        ) : (
          <Tip
            title={
              record.is_document_uploaded !== null
                ? record.is_document_uploaded
                  ? "Yes"
                  : "No"
                : "N/A"
            }
          >
            <span className="textcolorgreen">
              {record.is_document_uploaded !== null
                ? record.is_document_uploaded
                  ? "Yes"
                  : "No"
                : "N/A"}
            </span>
          </Tip>
        );
      },
    },
    //   ]
    // : []),
    {
      title: "Remarks",
      width: 200,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name="remarks">
            <Input.TextArea
              placeholder="Enter remarks to justify for back date entry."
              rows={2}
              maxLength={500}
              showCount
              style={{ width: "500px" }}
            />
          </Form.Item>
        ) : (
          <Tip title={record.remarks || "N/A"}>
            <span
              className="textcolorgreen"
              style={{
                display: "inline-block",
                width: "200px",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {record.remarks || "N/A"}
            </span>
          </Tip>
        );
      },
    },
    // {
    //   title: "Action",
    //   dataIndex: "operation",
    //   width: 100,
    //   render: (_, record) => {
    //     const editableRow = isEditing(record);
    //     const canEdit = isCreatedToday(record.created_at);

    //     if (editableRow) {
    //       return (
    //         <span>
    //           <Button
    //             type="link"
    //             onClick={() => save(record.key)}
    //             style={{ marginRight: 8 }}
    //           >
    //             Save
    //           </Button>
    //           <Button type="link" onClick={cancel}>
    //             Cancel
    //           </Button>
    //         </span>
    //       );
    //     } else if (canEdit || !record.proposal_id) {
    //       return (
    //         <EditOutlined
    //           style={{ marginRight: "8px", color: "blue", fontSize: "20px" }}
    //           onClick={() => edit(record)}
    //         />
    //       );
    //     }
    //     return null;
    //   },
    // },
  ];

  const projectOptions = projects?.map((project) => ({
    value: project.id,
    label: `${project.earthood_id} / ${project.project_name}`,
  }));
  const taskOptions = tasks.map((task) => ({
    value: task.id,
    label: `${task.name}`,
  }));
  const roleOptions = roles.map((role) => ({
    value: role.id,
    label: `${role.name}`,
  }));
  const statusOptionsData = [
    { id: 1, value: "Work in progress", label: "Work in progress" },
    { id: 2, value: "Complete", label: "Complete" },
    { id: 3, value: "Allocated to other", label: "Allocated to other" },
    { id: 4, value: "Cancelled", label: "Cancelled" },
  ];
  const statusOption = statusOptionsData.map((status) => ({
    value: status.id,
    label: `${status.value}`,
  }));

  return (
    <>
      <Header />
      <SideNavbar />
      <div className="content-wrapper bg-white">
        <div className="content">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <h3 className="flex text-center mt-4 my-0">Actual Timesheet</h3>
              <div className="col-12">
                <div className="mx-lg-3 my-3 border-1 border border-light-subtle p-0 rounded-3 mt-5">
                  <div className="row my-3 mx-3">
                    <div className="row">
                      <div className="mb-3 col-6 col-sm-3 col-md-3 col-lg-3">
                        <label className="text-capitalize textcolumntitle fw-bold font12px">
                          Project Name
                        </label>
                        <div>
                          <Select
                            id="project"
                            name="project"
                            options={projectOptions}
                            value={filters.project_id}
                            onChange={(value) =>
                              handleImmediateFilterChange("project_id", value)
                            }
                            placeholder="Select Project"
                            isSearchable
                            isClearable
                            style={{ width: "200px" }}
                          />
                        </div>
                      </div>
                      <div className="mb-3 col-6 col-sm-3 col-md-3 col-lg-3">
                        <label className="text-capitalize textcolumntitle fw-bold font12px">
                          Task
                        </label>
                        <div>
                          <Select
                            id="task"
                            name="task"
                            options={taskOptions}
                            value={filters.task_id}
                            onChange={(value) =>
                              handleImmediateFilterChange("task_id", value)
                            }
                            placeholder="Select Task"
                            isSearchable
                            isClearable
                            style={{ width: "200px" }}
                          />
                        </div>
                      </div>
                      <div className="mb-3 col-6 col-sm-3 col-md-3 col-lg-3">
                        <label className="text-capitalize textcolumntitle fw-bold font12px">
                          Role
                        </label>
                        <div>
                          <Select
                            id="role"
                            name="role"
                            options={roleOptions}
                            value={filters.role_id}
                            onChange={(value) =>
                              handleImmediateFilterChange("role_id", value)
                            }
                            placeholder="Select Role"
                            isSearchable
                            isClearable
                            style={{ width: "200px" }}
                          />
                        </div>
                      </div>

                      <div className="mb-3 col-6 col-sm-3 col-md-3 col-lg-3">
                        <label className="text-capitalize textcolumntitle fw-bold font12px">
                          Status
                        </label>
                        <div>
                          <Select
                            id="role"
                            name="role"
                            options={statusOption}
                            value={filters.status || ""}
                            onChange={(value) =>
                              handleImmediateFilterChange("status", value)
                            }
                            placeholder="Select Status"
                            isSearchable
                            isClearable
                            style={{ width: "200px" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                        <div className="mb-3">
                          <label className="text-capitalize textcolumntitle fw-bold font12px">
                            Start Date
                          </label>
                          <DatePicker
                            onChange={setstartDate}
                            placeholder="From Date"
                            style={{ width: "100%" }}
                            className="rounded-2"
                            format={dateFormat}
                            showTime={false}
                            value={startDate}
                            disabledDate={(current) =>
                              current && current > moment().endOf("day")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                        <div className="mb-3">
                          <label className="text-capitalize textcolumntitle fw-bold font12px">
                            End Date
                          </label>
                          <DatePicker
                            onChange={setendDate}
                            placeholder="To Date"
                            style={{ width: "100%" }}
                            className="rounded-2"
                            format={dateFormat}
                            showTime={false}
                            value={endDate}
                            disabledDate={(current) =>
                              current && current > moment().endOf("day")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-4 col-md-3 col-lg-2 mt-4">
                        <button
                          className="btn btn-success btn-md rounded-2 me-2 w-100"
                          onClick={handleSearchByColumn}
                        >
                          Search
                        </button>
                      </div>
                      {/* <div className="col-12 col-sm-4 col-md-3 col-lg-2 mt-4">
                        <button
                          className="btn btn-success btn-md rounded-2"
                          onClick={addNewRow}
                        >
                          Add
                        </button>
                      </div> */}
                      <div className="col-12 col-sm-4 col-md-3 col-lg-2 mt-4">
                        <button
                          className="btn btn-primary btn-md rounded-2"
                          onClick={() =>
                            exportTimesheet(filters, startDate, endDate, get_sbu_time_sheetData)
                          }
                        >
                          Export to Excel
                        </button>
                      </div>
                    </div>

                    <div className="col-12 ">
                      <Form form={form} component={false}>
                        <Table
                          className="border-1 border ronded-0 border-subtle-light px-0"
                          columns={baseColumns}
                          dataSource={dataSource}
                          rowKey="key"
                          pagination={{
                            ...pagination,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "50", "100", "200", "500"],
                            showTotal: (total, range) =>
                              `${range[0]}-${range[1]} of ${total} items`,
                          }}
                          onChange={handleTableChange}
                          loading={loader}
                          scroll={{ x: true }}
                        />
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SBUTimesheet;
